import { render, staticRenderFns } from "./ElementSelector.vue?vue&type=template&id=a9bdbfd8&scoped=true&"
import script from "./ElementSelector.js?vue&type=script&lang=js&"
export * from "./ElementSelector.js?vue&type=script&lang=js&"
import style0 from "./ElementSelector.scss?vue&type=style&index=0&id=a9bdbfd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bdbfd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
